"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatsOperation = void 0;
exports.getStatsOperation = {
    method: 'GET',
    name: 'getStats',
    id: 'getStats',
    groupName: 'streams',
    urlPathPattern: '/stats',
    getRequestUrlParams: getRequestUrlParams,
    deserializeResponse: deserializeResponse,
    serializeRequest: serializeRequest,
    deserializeRequest: deserializeRequest,
};
// Methods
function getRequestUrlParams() {
    return {};
}
function deserializeResponse(jsonResponse) {
    return jsonResponse;
}
function serializeRequest() {
    return undefined;
}
function deserializeRequest() {
    return {};
}
//# sourceMappingURL=getStatsOperation.js.map